/**
 * UI that belongs to an editor inside a dialog but is mounted on `document.body`.
 *
 * MathLive attaches its virtual keyboard and context menu to the body, not to
 * the field, so Radix classes a click on them as an interaction *outside* the
 * dialog and dismisses it — losing the author's work mid-formula. These aren't
 * Radix layers, so Radix's own nested-dismissal handling doesn't cover them.
 *
 * Matching on the library's own class names keeps ordinary backdrop-click
 * dismissal working everywhere else.
 */
const EXTERNAL_EDITOR_LAYERS = [
  '.ML__keyboard', // MathLive virtual keyboard
  '.ML__menu', // MathLive context menu
  '.ui-menu-container', // MathLive menu container
  'math-field', // the field element itself (shadow host)
].join(',');

/** True when the event target belongs to an out-of-tree editor layer. */
export function isExternalEditorLayer(target: EventTarget | null): boolean {
  const node = target as Node | null;
  const el =
    node instanceof Element ? node : (node?.parentElement as Element | null | undefined) ?? null;
  return Boolean(el?.closest?.(EXTERNAL_EDITOR_LAYERS));
}
